import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      smartSearch: 'Smart Search',
      profiles: 'Profiles',
      importUrls: 'Import URLs',
      signOff: 'Sign Off',
      language: 'Language',
      english: 'English',
      hebrew: 'Hebrew',
      
      // Statuses and Actions
      open: 'Open',
      delete: 'Delete',
      undelete: 'Undelete',
      archive: 'Archive',
      unarchive: 'Unarchive',
      active: 'Active',
      archived: 'Archived',
      deleted: 'Deleted',
      allStatuses: 'All Statuses',
      new: 'Queued',
      queued: 'Queued',
      processing: 'Processing',
      ready: 'Ready',
      cancelled: 'Cancelled',
      searchResults: 'Search Results',
      searchResultsSubtitle: 'View and manage search results',
      actions: 'Actions',
      
      // Smart Search Page
      searchTerm: 'Search Term',
      searchType: 'Search Type',
      search: 'Search',
      newSearch: 'New Search',
      businessSearch: 'Places Search',
      googleSearch: 'Google Search',
      searchQuery: 'Search Term',
      googleSearchPlaceholder: 'Enter your search...',
      searchOnGoogle: 'Search on Google',
      contact: 'Contact',
      submission: 'Submission',
      lead: 'Lead',
      opportunity: 'Opportunity',
      unknown: 'Unknown',
      searchTermPlaceholder: 'Enter search term...',
      searchTypePlaceholder: 'Select search type',
      smartSearchSubtitle: 'Search across contacts, submissions, leads, and opportunities',
      whatLabel: 'What',
      whatPlaceholder: 'Coffee shops, restaurants...',
      whereLabel: 'Where',
      wherePlaceholder: 'Los Angeles, Manhattan...',
      readyToDiscover: 'Ready to Discover?',
      enterSearchTermToFind: 'Enter a search term and select a type to find what you\'re looking for.',
      
      // Results
      title: 'Title',
      url: 'URL',
      domain: 'Domain',
      prefill: 'Prefill',
      submit: 'Submit',
      checkWebsite: 'Scan Site',
      autoScanning: 'Auto-scanning sites',
      bulkScan: 'Bulk Scan',
      scanning: 'Scanning',
      errors: 'errors',
      selectDestination: 'Send To',
      website: 'Website',
      messageCopied: 'Message Copied!',
      noResults: 'No results found',
      filterResults: 'Filter results...',
      loading: 'Loading...',
      moreResults: 'More Results',
      researchingSites: 'Researching relevant sites...',
      analyzingRelevance: 'Analyzing relevance...',
      prioritizing: 'Prioritizing results...',
      almostThere: 'Almost there...',
      
      // Common
      result: 'result',
      results: 'results',
      appName: 'PeleGoal',
      comingSoon: 'Coming Soon',
      manageProfiles: 'Manage user profiles and settings',
      tryAdjustingSearch: 'Try adjusting your search terms or search type.',
      user: 'User',
      errorLoadingProfiles: 'Error loading profiles',
      noProfilesFound: 'No profiles found',
      deleting: 'Deleting...',
      deleteProfile: 'Delete Profile',
      deleteProfileConfirmation: 'Are you sure you want to delete "{{profileName}}"? This action cannot be undone.',
      
      // Profile Edit Page
      createProfile: 'Create Profile',
      newProfile: 'New Profile',
      editProfile: 'Edit Profile',
      profileEditSubtitle: 'Configure profile settings and fields',
      profileName: 'Profile Name',
      profileNamePlaceholder: 'Enter profile name',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      next: 'Next',
      edit: 'Edit',
      fieldRequired: 'This field is required',
      invalidEmail: 'Please enter a valid email address',
      invalidUrl: 'Please enter a valid URL',
      errorLoadingProfile: 'Error loading profile. Please try again.',
      
      // Profile Selection Modal
      selectProfile: 'Select Profile',
      selectedProfile: 'Selected Profile',
      submittingResult: 'Submitting Result',
      business: 'Business',
      restaurant: 'Restaurant',
      
      // AI Content Modal
      aiContentGenerator: 'AI Content Generator',
      aiNotes: 'Select the target content template notes',
      aiNotesPlaceholder: 'For example: may I have the details of the website owner, I would like to discuss a business opportunity',
      generateContent: 'Generate Content',
      generating: 'Generating...',
      writeManually: 'Write Manually',
      backToAi: 'Back to Content Generation',
      messageContent: 'Message Content',
      load: 'Load',
      saveConfirmation: 'Message saved successfully!',
      loadingExistingData: 'Loading existing data...',
      aiGeneratedContent: 'Message to {{domain}}',
      regenerate: 'Regenerate',
      submitting: 'Submitting...',
      searchProfiles: 'Search profiles...',
      noProfilesFoundInSearch: 'No profiles found matching your search.',
      noProfilesAvailable: 'No profiles available. Create a profile first.',
      profileRequired: 'Profile Required',
      noProfilesSetupRequired: 'You need to set up a profile before you can submit results. Click OK to create your first profile.',
      ok: 'OK',
      
      // Prelaunch Notice
      prelaunchLimit: 'Prelaunch Beta Limit',
      prelaunchLimitDescription: 'During our prelaunch phase, searches are limited to 10 per day. Thank you for testing our platform!',
      
      // Search Progress Steps
      dailySearchQuotaReached: 'You\'ve reached the daily search quota',
      searchNeedsRefinement: 'Ineffective Search',
      searchNeedsRefinementMessage: 'This search didn\'t return any actionable results. Please try refining your search term to get better results.',
      
      // Redeem Page
      redeem: 'Redeem',
      redeemCoupon: 'Redeem Coupon',
      couponCode: 'Coupon Code',
      couponCodePlaceholder: 'Enter your coupon code',
      redeemCouponDescription: 'Enter your coupon code to activate your subscription',
      redeeming: 'Redeeming...',
      couponRedeemed: 'Coupon Redeemed Successfully',
      couponRedeemedMessage: 'Your subscription has been activated successfully!',
      invalidCoupon: 'Invalid Coupon Code',
      invalidCouponMessage: 'The coupon code you entered is not valid or has already been used.',
      redeemError: 'Redemption Error',
      redeemErrorMessage: 'There was an error processing your coupon. Please try again.',
      
      // Chrome Extension Modal
      chromeExtensionRequired: 'Why You Need the PeleGoal Extension',
      chromeExtensionRecommended: 'Chrome Extension Recommended',
      chromeExtensionNotInstalled: 'The PeleGoal Chrome extension is not installed or enabled.',
      chromeExtensionRecommendedMessage: 'For the best experience, we recommend installing the PeleGoal Chrome extension to automatically fill forms.',
      chromeExtensionRequiredMessage: 'The PeleGoal Chrome extension is required for full functionality:',
      chromeExtensionReason1: 'Import URLs directly from Google search results',
      chromeExtensionReason2: 'Auto-fill contact forms with your profile data',
      chromeExtensionInstructions: 'To automatically fill forms with your profile data, please:',
      downloadExtension: 'Download Extension',
      copyAndOpen: 'Copy & Open Manually',
      copiedRedirecting: 'Copied.. Now Redirecting',
      downloadExtensionZip: 'Download the extension ZIP file',
      extractZip: 'Extract the ZIP file to a folder',
      openChromeExtensions: 'Open a new tab and type <strong>chrome://extensions/</strong>',
      enableDeveloperMode: 'Enable "Developer mode" toggle (top right corner)',
      loadUnpacked: 'Click "Load unpacked" (top left corner) and select the extracted folder',
      refreshPage: 'Refresh this page and try again',
      extensionInstallComplete: 'Extension installation complete!',
      
      // Extension Recommendation Modal
      extensionRecommended: 'Extension Recommended',
      extensionRecommendedMessage: 'Search results will be in much better quality if the Chrome extension is installed.',
      installExtension: 'Install Extension',
      continueWithoutExtension: 'Continue Without Extension',
      
      // Profile Fields - Contact
      
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      position: 'Position',
      linkedin: 'LinkedIn Profile',
      
      firstNamePlaceholder: 'Enter first name',
      lastNamePlaceholder: 'Enter last name',
      emailPlaceholder: 'Enter email address',
      phonePlaceholder: 'Enter phone number',
      companyPlaceholder: 'Enter company name',
      positionPlaceholder: 'Enter job position',
      linkedinPlaceholder: 'Enter LinkedIn profile URL',
      
      // Profile Fields - Submission
      submissionId: 'Submission ID',
      submissionDate: 'Submission Date',
      status: 'Status',
      description: 'Description',
      priority: 'Priority',
      submissionIdPlaceholder: 'Enter submission ID',
      submissionDatePlaceholder: 'Select submission date',
      descriptionPlaceholder: 'Enter description',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      underReview: 'Under Review',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent',
      
      // Import URLs Page
      importUrlsSubtitle: 'Import URLs to create a new search query',
      importUrlsFormTitle: 'Import URLs',
      searchTermTitle: 'Title',
      searchTermTitlePlaceholder: 'Enter a title for this import',
      urlsLabel: 'URLs',
      urlsPlaceholder: 'Enter URLs, one per line...\nhttps://example1.com\nhttps://example2.com',
      urlsHint: 'Enter one URL per line',
      noUrlsProvided: 'Please enter at least one URL',
      importSuccess: 'URLs imported successfully!',
      importError: 'Failed to import URLs. Please try again.',
      importing: 'Importing...',
    }
  },
  he: {
    translation: {
      // Navigation
      smartSearch: 'חיפוש חכם',
      profiles: 'פרופילים',
      importUrls: 'ייבוא כתובות',
      signOff: 'התנתק',
      language: 'שפה',
      english: 'English',
      hebrew: 'עברית',
      
      // Statuses and Actions
      open: 'פתח',
      delete: 'מחק',
      undelete: 'בטל מחיקה',
      archive: 'ארכיון',
      unarchive: 'בטל ארכיון',
      active: 'פעיל',
      archived: 'אורכב',
      deleted: 'נמחק',
      allStatuses: 'כל הסטטוסים',
      new: 'בתור',
      queued: 'בתור',
      processing: 'בתהליך',
      ready: 'מוכן',
      cancelled: 'בוטל',
      searchResults: 'תוצאות חיפוש',
      searchResultsSubtitle: 'צפה ונהל תוצאות חיפוש',
      actions: 'פעולות',
      
      // Smart Search Page
      searchTerm: 'מונח חיפוש',
      searchType: 'סוג חיפוש',
      search: 'חפש',
      newSearch: 'חיפוש חדש',
      businessSearch: 'חיפוש מקומות',
      googleSearch: 'חיפוש גוגל',
      searchQuery: 'מונח חיפוש',
      googleSearchPlaceholder: 'הזן את החיפוש שלך...',
      searchOnGoogle: 'חפש בגוגל',
      contact: 'צור קשר',
      submission: 'הגשה',
      lead: 'ליד',
      opportunity: 'הזדמנות',
      unknown: 'לא ידוע',
      searchTermPlaceholder: 'הזן מונח חיפוש...',
      searchTypePlaceholder: 'בחר סוג חיפוש',
      smartSearchSubtitle: 'חפש בין אנשי קשר, הגשות, לידים והזדמנויות',
      whatLabel: 'מה',
      whatPlaceholder: 'בתי קפה, מסעדות...',
      whereLabel: 'איפה',
      wherePlaceholder: 'לוס אנג\'לס, מנהטן...',
      readyToDiscover: 'מוכן לגלות?',
      enterSearchTermToFind: 'הזן מונח חיפוש ובחר סוג כדי למצוא את מה שאתה מחפש.',
      
      // Results
      title: 'כותרת',
      url: 'כתובת URL',
      domain: 'דומיין',
      prefill: 'מלא מראש',
      submit: 'שלח',
      checkWebsite: 'סרוק אתר',
      autoScanning: 'סריקה אוטומטית של אתרים',
      bulkScan: 'סריקה מרובה',
      scanning: 'סורק',
      errors: 'שגיאות',
      selectDestination: 'שלח ל',
      website: 'אתר',
      messageCopied: 'ההודעה הועתקה!',
      noResults: 'לא נמצאו תוצאות',
      filterResults: 'סינון תוצאות...',
      loading: 'טוען...',
      moreResults: 'תוצאות נוספות',
      researchingSites: 'חוקר אתרים רלוונטיים...',
      analyzingRelevance: 'מנתח רלוונטיות...',
      prioritizing: 'מסדר לפי עדיפות...',
      almostThere: 'כמעט שם...',
      
      // Common
      result: 'תוצאה',
      results: 'תוצאות',
      appName: 'פלא-פיינדר',
      comingSoon: 'בקרוב',
      manageProfiles: 'נהל פרופילים והגדרות משתמש',
      tryAdjustingSearch: 'נסה לשנות את מונחי החיפוש או סוג החיפוש.',
      user: 'משתמש',
      errorLoadingProfiles: 'שגיאה בטעינת פרופילים',
      noProfilesFound: 'לא נמצאו פרופילים',
      deleting: 'מוחק...',
      deleteProfile: 'מחק פרופיל',
      deleteProfileConfirmation: 'האם אתה בטוח שברצונך למחוק את "{{profileName}}"? פעולה זו לא ניתנת לביטול.',
      
      // Profile Edit Page
      createProfile: 'צור פרופיל',
      newProfile: 'פרופיל חדש',
      editProfile: 'ערוך פרופיל',
      profileEditSubtitle: 'הגדר הגדרות ושדות פרופיל',
      profileName: 'שם פרופיל',
      profileNamePlaceholder: 'הזן שם פרופיל',
      save: 'שמור',
      saving: 'שומר...',
      cancel: 'ביטול',
      next: 'הבא',
      edit: 'ערוך',
      fieldRequired: 'שדה זה נדרש',
      invalidEmail: 'אנא הזן כתובת אימייל תקינה',
      invalidUrl: 'אנא הזן כתובת URL תקינה',
      errorLoadingProfile: 'שגיאה בטעינת הפרופיל. אנא נסה שוב.',
      
      // Profile Selection Modal
      selectProfile: 'בחר פרופיל',
      selectedProfile: 'פרופיל נבחר',
      submittingResult: 'שולח תוצאה',
      business: 'עסק',
      restaurant: 'מסעדה',
      
      // AI Content Modal
      aiContentGenerator: 'מחולל תוכן בינה מלאכותית',
      aiNotes: 'בחר הערות תבנית תוכן היעד',
      aiNotesPlaceholder: 'למשל: אני מבקש לקבל את פרטי בעל האתר, ברצוני לדון בהזדמנות עסקית',
      generateContent: 'ייצר תוכן',
      generating: 'מייצר...',
      writeManually: 'כתוב באופן ידני',
      backToAi: 'חזור ליצירת תוכן',
      messageContent: 'תוכן הודעה',
      load: 'טען',
      saveConfirmation: 'ההודעה נשמרה בהצלחה!',
      loadingExistingData: 'טוען נתונים קיימים...',
      aiGeneratedContent: 'הודעה אל {{domain}}',
      regenerate: 'ייצר מחדש',
      submitting: 'שולח...',
      searchProfiles: 'חפש פרופילים...',
      noProfilesFoundInSearch: 'לא נמצאו פרופילים התואמים לחיפוש שלך.',
      noProfilesAvailable: 'אין פרופילים זמינים. צור פרופיל תחילה.',
      profileRequired: 'נדרש פרופיל',
      noProfilesSetupRequired: 'עליך להגדיר פרופיל לפני שתוכל לשלוח תוצאות. לחץ אישור כדי ליצור את הפרופיל הראשון שלך.',
      ok: 'אישור',
      
      // Prelaunch Notice
      prelaunchLimit: 'הגבלת גרסה ניסיון',
      prelaunchLimitDescription: 'במהלך שלב הקדם השקה, חיפושים מוגבלים ל-10 ביום. תודה שאתם בודקים את הפלטפורמה שלנו!',
      
      // Search Progress Steps
      dailySearchQuotaReached: 'הגעת למכסת החיפושים היומית',
      searchNeedsRefinement: 'החיפוש דורש שיפור',
      searchNeedsRefinementMessage: 'חיפוש זה לא החזיר תוצאות פעילות. אנא נסה לשפר את מונחי החיפוש או סוג החיפוש כדי לקבל תוצאות טובות יותר.',
      
      // Redeem Page
      redeem: 'פדיון',
      redeemCoupon: 'פדיון קופון',
      couponCode: 'קוד קופון',
      couponCodePlaceholder: 'הזן את קוד הקופון שלך',
      redeemCouponDescription: 'הזן את קוד הקופון שלך כדי להפעיל את המנוי',
      redeeming: 'מפדה...',
      couponRedeemed: 'הקופון נפדה בהצלחה',
      couponRedeemedMessage: 'המנוי שלך הופעל בהצלחה!',
      invalidCoupon: 'קוד קופון לא תקין',
      invalidCouponMessage: 'קוד הקופון שהזנת לא תקין או כבר שומש.',
      redeemError: 'שגיאת פדיון',
      redeemErrorMessage: 'אירעה שגיאה בעיבוד הקופון שלך. אנא נסה שוב.',
      
      // Chrome Extension Modal
      chromeExtensionRequired: 'למה כדאי להתקין את תוסף PeleGoal',
      chromeExtensionRecommended: 'תוסף Chrome מומלץ',
      chromeExtensionNotInstalled: 'תוסף PeleGoal Chrome לא מותקן או לא מופעל.',
      chromeExtensionRecommendedMessage: 'לחוויה הטובה ביותר, אנו ממליצים להתקין את תוסף PeleGoal Chrome למילוי אוטומטי של טפסים.',
      chromeExtensionRequiredMessage: 'תוסף PeleGoal Chrome נדרש לפונקציונליות מלאה:',
      chromeExtensionReason1: 'ייבוא כתובות ישירות מתוצאות חיפוש Google',
      chromeExtensionReason2: 'מילוי אוטומטי של טופסי יצירת קשר עם נתוני הפרופיל שלך',
      chromeExtensionInstructions: 'כדי למלא אוטומטית טפסים עם נתוני הפרופיל שלך, אנא:',
      downloadExtension: 'הורד תוסף',
      copyAndOpen: 'העתק ופתח ידנית',
      copiedRedirecting: 'הועתק.. מפנה כעת',
      downloadExtensionZip: 'הורד את קובץ ה-ZIP של התוסף',
      extractZip: 'חלץ את קובץ ה-ZIP לתיקייה',
      openChromeExtensions: 'פתח טאב חדש והקלד chrome://extensions/',
      enableDeveloperMode: 'הפעל את המתג "מצב מפתח"',
      loadUnpacked: 'לחץ על "טען לא ארוז" ובחר את התיקייה החלצה',
      refreshPage: 'רענן את הדף הזה ונסה שוב',
      extensionInstallComplete: 'התקנת התוסף הושלמה!',
      
      // Extension Recommendation Modal
      extensionRecommended: 'תוסף מומלץ',
      extensionRecommendedMessage: 'תוצאות החיפוש יהיו באיכות טובה יותר אם התוסף של Chrome מותקן.',
      installExtension: 'התקן תוסף',
      continueWithoutExtension: 'המשך ללא תוסף',
      
      // Profile Fields - Contact
      
      firstName: 'שם פרטי',
      lastName: 'שם משפחה',
      email: 'אימייל',
      phone: 'טלפון',
      company: 'חברה',
      position: 'תפקיד',
      linkedin: 'פרופיל LinkedIn',
      
      firstNamePlaceholder: 'הזן שם פרטי',
      lastNamePlaceholder: 'הזן שם משפחה',
      emailPlaceholder: 'הזן כתובת אימייל',
      phonePlaceholder: 'הזן מספר טלפון',
      companyPlaceholder: 'הזן שם חברה',
      positionPlaceholder: 'הזן תפקיד',
      linkedinPlaceholder: 'הזן כתובת פרופיל LinkedIn',
      
      // Profile Fields - Submission
      submissionId: 'מזהה הגשה',
      submissionDate: 'תאריך הגשה',
      status: 'סטטוס',
      description: 'תיאור',
      priority: 'עדיפות',
      submissionIdPlaceholder: 'הזן מזהה הגשה',
      submissionDatePlaceholder: 'בחר תאריך הגשה',
      descriptionPlaceholder: 'הזן תיאור',
      pending: 'ממתין',
      approved: 'אושר',
      rejected: 'נדחה',
      underReview: 'בבדיקה',
      low: 'נמוכה',
      medium: 'בינונית',
      high: 'גבוהה',
      urgent: 'דחופה',
      
      // Import URLs Page
      importUrlsSubtitle: 'ייבוא כתובות ליצירת שאילתת חיפוש חדשה',
      importUrlsFormTitle: 'ייבוא כתובות',
      searchTermTitle: 'כותרת',
      searchTermTitlePlaceholder: 'הזן כותרת לייבוא זה',
      urlsLabel: 'כתובות',
      urlsPlaceholder: 'הזן כתובות, אחת בכל שורה...\nhttps://example1.com\nhttps://example2.com',
      urlsHint: 'הזן כתובת אחת בכל שורה',
      noUrlsProvided: 'אנא הזן לפחות כתובת אחת',
      importSuccess: 'הכתובות יובאו בהצלחה!',
      importError: 'ייבוא הכתובות נכשל. אנא נסה שוב.',
      importing: 'מייבא...',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n; 